import React from 'react';
import { FusionSectionText, FusionSectionTitle, FusionSectionCaption } from '@benzinga/ui';
import { Button } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

export interface ReviewedByBenzingaProps {
  button_href: string;
  button_title: string;
  caption: string;
  image_src: string;
  subtitle: string;
  title: string;
}

export const ReviewedByBenzinga = ({
  button_href,
  button_title,
  caption,
  image_src,
  subtitle,
  title,
}: ReviewedByBenzingaProps) => {
  return (
    <ReviewedByBenzingaWrapper className="content-wrapper">
      <FusionSectionCaption className="caption">{caption}</FusionSectionCaption>
      <FusionSectionTitle className="title">{title}</FusionSectionTitle>
      <FusionSectionText className="description">{subtitle}</FusionSectionText>
      <div className="reward-actions-wrapper">
        <Button as="a" className="show-more-button" href={button_href} size="lg" variant="flat-blue">
          {button_title}
        </Button>
        {image_src && <img alt={caption} className="reward-image" src={image_src} />}
      </div>
    </ReviewedByBenzingaWrapper>
  );
};

const ReviewedByBenzingaWrapper = styled.div`
  &.content-wrapper {
    position: relative;
    padding: 20px;
    border-radius: 4px;
    background: #f2f8ff;

    @media screen and (max-width: 959px) {
      padding: 12px;
    }
  }

  .caption {
    margin-bottom: 12px;
    text-transform: unset;
  }

  .title {
    max-width: 492px;
    margin-bottom: 8px;

    @media screen and (max-width: 959px) {
      max-width: 314px;
    }

    @media screen and (max-width: 767px) {
      max-width: 416px;
    }
  }

  .description {
    max-width: 382px;
    margin-bottom: 24px;
  }

  .reward-actions-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .show-more-button {
    text-transform: uppercase;
  }

  .reward-image {
    position: absolute;
    right: 40px;
    bottom: 50%;
    height: 266px;
    width: auto;
    transform: translateY(50%);

    @media screen and (max-width: 959px) {
      height: 230px;
    }

    @media screen and (max-width: 767px) {
      height: 70px;
      right: 12px;
      bottom: 12px;
      transform: unset;
    }

    @media screen and (max-width: 567px) {
      position: static;
      height: 56px;
    }
  }
`;

ReviewedByBenzinga.defaultProps = {
  attrs: {
    data: {
      buttonTitle: 'Show Winners',
      buttonUrl: '',
      caption: 'Reviewed by Benzinga',
      description: 'Thanks to this, you can easily choose your favorite for the services you need.',
      imageSrc: '/next-assets/images/benzingaRewardImg.png',
      title: 'We review & reward the best companies in various industries',
    },
  },
};
